import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CheckoutCanceled() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
          className="w-20 h-20 mx-auto mb-6 rounded-full bg-muted flex items-center justify-center"
        >
          <XCircle className="w-10 h-10 text-muted-foreground" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <h1 className="text-3xl font-bold mb-2">Checkout Canceled</h1>
          
          <p className="text-muted-foreground mb-8">
            No worries! Your checkout was canceled and you haven't been charged. 
            You can upgrade to Pro anytime from the app.
          </p>

          <div className="flex flex-col gap-3">
            <Button 
              onClick={() => navigate('/app')} 
              size="lg"
              className="w-full"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to App
            </Button>
            
            <Button 
              variant="outline"
              onClick={() => navigate('/#pricing')} 
              size="lg"
              className="w-full"
            >
              View Pricing
            </Button>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
}
